import { render } from "./RegisterMask.vue?vue&type=template&id=1073a9ff&scoped=true"
import script from "./RegisterMask.vue?vue&type=script&lang=js"
export * from "./RegisterMask.vue?vue&type=script&lang=js"

import "./RegisterMask.vue?vue&type=style&index=0&id=1073a9ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1073a9ff"]])

export default __exports__